import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { loadConfig } from "@rtvloco/platform/env";
import { validateEnv } from "./config/envValidation";
import { themeManager } from "@rtvloco/theme/ThemeManager";
import "./styles.css";
import "./i18n/config";


const AppLoadingSkeleton = () => (
  <div className="pulse-loading-skeleton">Loading Pulse...</div>
);

function initializeDeferredTracing(): void {
  const initialize = () => {
    void import("./observability/tracing").then(({ initAppTracing }) => initAppTracing());
  };
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(initialize, { timeout: 3_000 });
  } else {
    setTimeout(initialize, 0);
  }
}

async function bootstrap() {
  await loadConfig();
  themeManager.initialize();
  const { default: App } = await import("./App");
  validateEnv();
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
      <Suspense fallback={<AppLoadingSkeleton />}>
        <App />
      </Suspense>
    </React.StrictMode>
  );
  initializeDeferredTracing();
}

bootstrap().catch((err) => {
  const root = document.getElementById("root");
  if (root) root.textContent = String(err);
});
